/*
 * Copyright (c) 2019 by Enrico Ansaloni <enrico.ansaloni@gmail.com>
 */

// core imports
import * as React from 'react';
import * as ReactDOM from 'react-dom';
// component imports
import App from './App';
//import * as serviceWorker from './serviceWorker';
// import sytle
import "./index.scss";

ReactDOM.render(<App/>, document.getElementById('root'));
// concurrent react...
// ReactDOM.createRoot(document.getElementById('root')).render(<App />);
